var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEur = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8276_14457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#043CAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8857 5.49887L12.001 5.17222L13.1162 5.49887L12.7896 4.38362L13.1162 3.26837L12.001 3.59502L10.8857 3.26837L11.2124 4.38362L10.8857 5.49887ZM10.8857 21.2684L12.001 20.9418L13.1162 21.2684L12.7896 20.1532L13.1162 19.0379L12.001 19.3646L10.8857 19.0379L11.2124 20.1532L10.8857 21.2684ZM19.8867 13.055L18.7715 13.3817L19.0981 12.2664L18.7715 11.1512L19.8867 11.4778L21.002 11.1512L20.6753 12.2664L21.002 13.3817L19.8867 13.055ZM3.00195 13.3817L4.1172 13.055L5.23245 13.3817L4.9058 12.2664L5.23245 11.1512L4.1172 11.4778L3.00195 11.1512L3.3286 12.2664L3.00195 13.3817ZM18.832 9.11363L17.7168 9.44028L18.0434 8.32503L17.7168 7.20978L18.832 7.53643L19.9473 7.20978L19.6206 8.32503L19.9473 9.44028L18.832 9.11363ZM4.05859 17.327L5.17384 17.0003L6.28909 17.327L5.96244 16.2117L6.28909 15.0965L5.17384 15.4231L4.05859 15.0965L4.38524 16.2117L4.05859 17.327ZM15.9468 6.22691L14.8315 6.55356L15.1582 5.43831L14.8315 4.32306L15.9468 4.64971L17.062 4.32306L16.7354 5.43831L17.062 6.55356L15.9468 6.22691ZM6.94385 20.2137L8.0591 19.8871L9.17435 20.2137L8.8477 19.0985L9.17435 17.9832L8.0591 18.3099L6.94385 17.9832L7.2705 19.0985L6.94385 20.2137ZM18.832 17.0003L17.7168 17.327L18.0434 16.2117L17.7168 15.0965L18.832 15.4231L19.9473 15.0965L19.6206 16.2117L19.9473 17.327L18.832 17.0003ZM4.05859 9.44028L5.17384 9.11363L6.28909 9.44028L5.96244 8.32503L6.28909 7.20978L5.17384 7.53643L4.05859 7.20978L4.38524 8.32503L4.05859 9.44028ZM15.9468 19.8871L14.8315 20.2137L15.1582 19.0985L14.8315 17.9832L15.9468 18.3099L17.062 17.9832L16.7354 19.0985L17.062 20.2137L15.9468 19.8871ZM6.94385 6.55356L8.0591 6.22691L9.17435 6.55356L8.8477 5.43831L9.17435 4.32306L8.0591 4.64971L6.94385 4.32306L7.2705 5.43831L6.94385 6.55356Z",
    fill: "#FFD429"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8276_14457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEur);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EUR.c10f20c0254e0f6767866cf2b011b08b.svg";